let currentlyActiveTab = null;
let currentlyActivePanel = null;

/**
 * Initializes the tab functionality for the staff info page.
 * This function sets up the initial state of the tabs and calls the necessary event handlers for tab switching.
 * 
 * @returns {void}
 */
function init() {
    const tabElement = document.querySelector('.staff-info-tabs');
    if (!tabElement) { return; }
    const tabList = tabElement.querySelector('[role="tablist"]');
    if (!tabList) { return; }
    const tabs = tabList.querySelectorAll('button');
    if (tabs.length === 0) { return; }

    
    for (let i = 0; i < tabs.length; i++) {
        if (i === 0) {
            tabs[i].setAttribute('aria-selected', 'true');
            currentlyActiveTab = tabs[i];
        } else {
            tabs[i].setAttribute('aria-selected', 'false');
            tabs[i].setAttribute('tabindex', '-1');
        }
    }
    
    const panels = tabElement.querySelectorAll('[role="tabpanel"]');
    panels[0].classList.remove('d-none');
    currentlyActivePanel = panels[0];


    directClickHandling(tabs);
    keyboardHandling(tabs);
}

/**
 * Adds a click event listener to each tab button.
 *
 * @param {Array} tabs - An array of tab button elements.
 * @returns {void}
 */
function directClickHandling(tabs) {
    tabs.forEach(tab => {
        tab.addEventListener('click', (event) => {
            event.preventDefault();
            updateTabs(tab);
        });
    });
}

/**
 * Tracks keyboard navigation for the tab buttons.
 * Simulates "click" to trigger the event added in `directClickHandling`.
 * 
 * @param {Array} tabs - An array of tab button elements.
 * @returns {void}
 */
function keyboardHandling(tabs) {
    document.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            let newIndex = Array.from(tabs).indexOf(currentlyActiveTab);

            if (event.key === 'ArrowLeft') {
                newIndex = (newIndex - 1 + tabs.length) % tabs.length;
            } else if (event.key === 'ArrowRight') {
                newIndex = (newIndex + 1) % tabs.length;
            }

            const targetTab = tabs[newIndex];
            targetTab.click(); // Trigger the click event to change the active tab
        }
    });
}

/**
 * "Deactivates" the currently active tab and activates the clicked tab.
 * 
 * @param {HTMLElement} tab 
 * @returns {void}
 */
function updateTabs(tab) {
    const targetTab = tab;
    const targetPanelId = targetTab.getAttribute('aria-controls');
    const targetPanel = document.getElementById(targetPanelId);

    if (currentlyActiveTab) {
        currentlyActiveTab.setAttribute('tabindex', '-1');
        const currentlyActivePanelId = currentlyActiveTab.getAttribute('aria-controls');
        currentlyActivePanel = document.getElementById(currentlyActivePanelId);
        currentlyActivePanel.classList.add('d-none');
        currentlyActiveTab.setAttribute('aria-selected', 'false');
    }

    // Show the clicked tab content
    targetPanel.classList.remove('d-none');
    targetTab.setAttribute('aria-selected', 'true');

    // Update currently active tab
    currentlyActiveTab = targetTab;
    currentlyActiveTab.setAttribute('tabindex', '0');
    setTimeout(() => {
        currentlyActiveTab.focus();
    }, 0);
}

init();